var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9518 10.8333C18.9518 12.6742 17.4594 14.1667 15.6185 14.1667C13.7776 14.1667 12.2852 12.6742 12.2852 10.8333C12.2852 8.99251 13.7776 7.5 15.6185 7.5C17.4594 7.5 18.9518 8.99251 18.9518 10.8333Z",
    fill: "#586A84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78516 20.8333C9.78516 17.6123 12.3969 15 15.6185 15C18.8401 15 21.4518 17.6123 21.4518 20.8333V21.6667C21.4518 22.1273 21.0787 22.5 20.6185 22.5H10.6185C10.3863 22.5 10.1762 22.404 10.025 22.251C9.93876 22.1631 9.87162 22.0573 9.83063 21.9385C9.80113 21.8538 9.78516 21.7627 9.78516 21.6667V20.8333Z",
    fill: "#586A84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnion);
export default __webpack_public_path__ + "static/media/icon-union.cff26fe25514260a51b2d2eb94b32416.svg";
export { ForwardRef as ReactComponent };